import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=7ed31f4a&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed31f4a')) {
      api.createRecord('7ed31f4a', component.options)
    } else {
      api.reload('7ed31f4a', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=7ed31f4a&", function () {
      api.rerender('7ed31f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UCHYKKrtV6av/JS/comp/ImgFallback2.vue"
export default component.exports